export type VerificationStatus = 'VERIFIED' | 'UNVERIFIED' | 'PENDING';
export const VerificationStatus = {
  VERIFIED: 'VERIFIED' as VerificationStatus,
  UNVERIFIED: 'UNVERIFIED' as VerificationStatus,
  PENDING: 'PENDING' as VerificationStatus,
};
